

































































import Vue from 'vue'
import { State } from 'vuex-class'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay } from '@/utils/dateTime'
import { Case, CaseType } from '@/modules/Case/interfaces/case'
import { Note } from '@/modules/Case/interfaces/note'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import AppTextarea from '@/components/AppTextarea.vue'
import AppDialog from '@/components/AppDialog.vue'
import { newNote, editNote, deleteNoteById } from '@/modules/Case/gql/case.gql'
import { User } from '@/modules/User/interfaces/user'

@Component({
  components: {
    AppTextarea,
    AppDialog
  }
})
export default class CaseDetailNote extends Vue {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case

  @State(state => state.user.me) me!: User

  newNote = ''
  edittingNote = ''
  checkedNote: Note | null = null

  isShowDeleteDialog = false

  get noteList () {
    return this.caseInfo.notes || []
  }

  dateTimeToDisplay = dateTimeToDisplay

  @Emit('success')
  onSuccess () {
    // do nothing
  }

  cancelEditting () {
    this.checkedNote = null
  }

  async newNoteHandler () {
    const { id } = this.caseInfo

    if (!this.newNote) {
      return
    }

    try {
      const result = await this.$apollo.mutate({
        mutation: newNote,
        variables: {
          noteInput: {
            content: this.newNote,
            masterId: Number(id),
            masterType: 'CASE'
          }
        }
      })

      const res = result.data.newNote
      if (res) {
        showNotification({
          msg: 'New note successfully',
          type: SnackType.Success
        })
        this.newNote = ''
        this.onSuccess()
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  async editNoteHandler () {
    if (!this.checkedNote || !this.edittingNote) {
      return
    }
    const { id } = this.caseInfo
    try {
      const result = await this.$apollo.mutate({
        mutation: editNote,
        variables: {
          noteInput: {
            content: this.edittingNote,
            masterId: Number(id),
            masterType: 'CASE'
          },
          noteId: Number(this.checkedNote.id)
        }
      })

      const res = result.data.editNote
      if (res) {
        showNotification({
          msg: 'Edit note successfully',
          type: SnackType.Success
        })
        this.edittingNote = ''
        this.checkedNote = null
        this.onSuccess()
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  editNote (item: Note) {
    this.checkedNote = item
    this.edittingNote = item.content
  }

  deleteNote (item: Note) {
    this.checkedNote = item
    this.isShowDeleteDialog = true
  }

  splitNoteContent (content: string) {
    if (!content) return []
    return content.split('\n')
  }

  ifEditting (item: Note) {
    return this.checkedNote && item.id === this.checkedNote.id
  }

  async deleteNoteConfirm () {
    if (!this.checkedNote) {
      return
    }
    const { id } = this.checkedNote
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteNoteById,
        variables: {
          noteId: Number(id)
        }
      })

      const res = result.data.deleteNoteById
      if (res) {
        showNotification({
          msg: 'Delete note successfully',
          type: SnackType.Success
        })
        this.isShowDeleteDialog = false
        this.newNote = ''
        this.checkedNote = null
        this.onSuccess()
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
